import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AccountSettingsStyled } from 'Features/accountSettings/routes/AccountSettings/AccountSettings.styled'
import { Billing } from 'Features/accountSettings/components/Billing/Billing'
import { PlanDetails } from 'Features/accountSettings/components/PlanDetails/PlanDetails'
import { UserManagement } from 'Features/accountSettings/components/UserManagement/UserManagement'
import { Tabs, TabType } from '@clickcease/cc-client-components-lib'
import { AddLogoImage } from 'Features/accountSettings/components/UserManagement/AddLogoImage/AddLogoImage'
import { VisibleOnlyToOwner } from 'src/hooks/VisibleOnlyToOwner'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { useLocation } from 'react-router-dom'

type BillingState = {
  openPaymentMethod?: boolean
  origin: 'trialEndedBanner' | 'trialEndedModal'
}

export const AccountSettings = () => {
  const { data: accountLimits } = useGetPackagingLimits()
  const { t } = useTranslation('accountSettings')
  const location = useLocation()
  const billingState = location.state as BillingState

  const tabs: TabType[] = [
    {
      id: 1,
      title: t('billing'),
      page: (
        <Billing
          openPaymentModal={billingState?.openPaymentMethod || false}
          flowOrigin={billingState?.origin}
        />
      ),
    },
    {
      id: 2,
      title: t('plan_details_title'),
      page: <PlanDetails />,
    },
    {
      id: 3,
      title: t('user_management_title'),
      page: <UserManagement />,
    },
  ]
  if (accountLimits?.logo) {
    tabs.push({
      id: 4,
      title: t('logo_title'),
      page: <AddLogoImage />,
    })
  }
  const [activeTab, setActiveTab] = useState<TabType>(tabs[0])

  return (
    <VisibleOnlyToOwner allowAdmin>
      <AccountSettingsStyled id={'account-settings-page'}>
        <Tabs tabs={tabs} activeTab={activeTab} onClick={setActiveTab} />
      </AccountSettingsStyled>
    </VisibleOnlyToOwner>
  )
}
